'use client';

import { ReactNode, createContext, use, useCallback, useState } from 'react';
import Box from '@mui/material/Box';
import { SectionColorContext } from './SectionColorContext';

export const CollectionVisibilityContext = createContext<{
  setVisible: (visible: boolean) => void;
}>({
  setVisible: () => {},
});

export const CollectionVisibilityProvider = ({
  children,
  index,
}: {
  children: ReactNode;
  index: number;
}): JSX.Element => {
  const [visible, setVisible] = useState<boolean>(true);

  const { setVisiblityAtIndex } = use(SectionColorContext);

  const setMyVisiblity = useCallback(
    (visible: boolean) => {
      setVisible(visible);
      setVisiblityAtIndex(index, visible);
    },
    [index, setVisiblityAtIndex],
  );

  return (
    <CollectionVisibilityContext.Provider value={{ setVisible: setMyVisiblity }}>
      <Box
        overflow="hidden"
        // instead of returning null, set the height to 0 when not visible
        // this prevents the search from re-running every time the visibility changes
        height={visible ? 'inherit' : 0}
      >
        {children}
      </Box>
    </CollectionVisibilityContext.Provider>
  );
};
